import { LocalDate } from '../../../utilities/local-date';
import { getDoneBy } from './get-done-by';
import { t } from 'src/i18n';

export function getAssetControlStatusText(assetControl, employeeNames, contacts) {
  if (assetControl.assetStatus === 'OK' || assetControl.assetStatus === 'NOT_OK') {
    const statusDate = LocalDate.fromString(assetControl.statusLastUpdatedAt).toStringForDisplayWithYear();
    const doneBy = getDoneBy(
      assetControl.statusLastUpdatedByEmployeeUuid || assetControl.statusLastUpdatedByContactUuid,
      employeeNames,
      contacts,
    );
    return t('assets.controlStatusDonePrefix') + statusDate + doneBy;
  }
  return '';
}
